const getPageType = (): string => {
  if (typeof window === "undefined") return "home";

  const path = window.location.pathname;

  if (path === "/" || path === "/index") {
    return "home";
  }

  if (path.includes("/places/search")) {
    return "search";
  }

  if (path.includes("/payment")) {
    return "payment";
  }

  if (path.includes("/form")) {
    return "bookform";
  }

  if (path.includes("/places/")) {
    return "property";
  }

  return "home";
};

export default getPageType;
